import { __assign, __extends } from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import { withTranslation } from 'react-i18next';
import withFileUpload from '../../_hocs/withFileUpload';
import { withVerification, } from '../../../VerificationPopup/withVerification';
import { MIME_CONFIG } from '../../../utils/mime';
import uploadDropzoneStyles from './UploadDropzone.scss';
var enhance = compose(withVerification, withFileUpload, withTranslation());
var UploadDropzone = /** @class */ (function (_super) {
    __extends(UploadDropzone, _super);
    function UploadDropzone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { dragInProgress: false };
        _this.dragCount = 0;
        _this.onFileDrop = function (acceptedFiles, rejectedFiles) {
            var _a = _this.props, uploadFiles = _a.uploadFiles, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup;
            if (acceptedFiles.length === 0) {
                return;
            }
            if (isVerificationNeeded) {
                pushVerificationPopup('submit');
                return;
            }
            uploadFiles(acceptedFiles.map(function (file) { return ({ file: file }); }));
        };
        _this.onDragEnterLeave = function (e) {
            e.preventDefault();
            switch (e.type) {
                case 'dragenter':
                    _this.dragCount++;
                    break;
                case 'dragleave':
                    _this.dragCount--;
                    break;
                case 'drop':
                    _this.dragCount = 0;
                    break;
                default:
                // noop
            }
            _this.setState({ dragInProgress: _this.dragCount === 1 });
        };
        return _this;
    }
    UploadDropzone.prototype.componentDidMount = function () {
        document.addEventListener('dragenter', this.onDragEnterLeave, true);
        document.addEventListener('dragleave', this.onDragEnterLeave, true);
        document.addEventListener('drop', this.onDragEnterLeave, true);
    };
    UploadDropzone.prototype.componentWillUnmount = function () {
        document.removeEventListener('dragenter', this.onDragEnterLeave);
        document.removeEventListener('dragleave', this.onDragEnterLeave);
        document.removeEventListener('drop', this.onDragEnterLeave);
    };
    UploadDropzone.prototype.render = function () {
        var _a = this.props, className = _a.className, t = _a.t;
        return (React.createElement("div", { className: classnames(uploadDropzoneStyles['root'], this.state.dragInProgress && uploadDropzoneStyles['root-active']) },
            React.createElement(Dropzone, { noClick: true, multiple: true, accept: MIME_CONFIG.forMediaManager.join(), onDrop: this.onFileDrop }, function (_a) {
                var isDragActive = _a.isDragActive, isDragAccept = _a.isDragAccept, isDragReject = _a.isDragReject, getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
                return (React.createElement("div", __assign({}, getRootProps({
                    className: classnames(uploadDropzoneStyles['dropzone'], className, isDragActive && uploadDropzoneStyles['dropzone-active'], isDragAccept && uploadDropzoneStyles['dropzone-accept'], isDragReject && uploadDropzoneStyles['dropzone-reject']),
                })),
                    React.createElement("input", __assign({}, getInputProps())),
                    isDragReject && t('mediapopup.upload.dropzone.reject'),
                    isDragActive && t('mediapopup.upload.dropzone.accept')));
            })));
    };
    return UploadDropzone;
}(React.Component));
export default enhance(UploadDropzone);
//# sourceMappingURL=UploadDropzone.connected.js.map